import { createRootRoute, Outlet } from '@tanstack/react-router'

function RootLayout() {
  return (
    <>
      <a href="#main-content" className="skip-to-content">
        Skip to content
      </a>
      <Outlet />
    </>
  )
}

export const Route = createRootRoute({
  component: RootLayout,
})
